module.exports = __webpack_public_path__ + "img/prize02-modal.6b0c9378.png";